import { ErrorHandler, Injectable } from '@angular/core';
import { ChatLoggingService } from '@mitel-internal/cloudlink-components-chat';

@Injectable()
export class ChatErrorHandler implements ErrorHandler {
  constructor(private chatLoggingService: ChatLoggingService) {}

  handleError(error) {
    this.chatLoggingService.error({
      logMessage: 'Uncaught chat component error',
      logParameters: [error]
    });
  }
}
